// Public pilot proposal, not a billing configuration or an immediately purchasable offer.
// Keep Damaya's catalog and customer entitlements separate.
export const apiPricing = {
  image: 0.08,
  videoMinute: 0.60,
  startingBalance: 200,
  trialDays: 14,
  trialImages: 100,
  trialVideoMinutes: 10,
  maxImageMegapixels: 12,
  maxVideoHeight: 1080,
  maxVideoFps: 30,
  maxVideoMinutes: 5,
} as const;

// Interpolation values for every pricing.* string (page copy and the FAQ schema share them).
export const pricingCopyValues = {
  ...apiPricing,
  imagePrice: apiPricing.image.toFixed(2),
  videoPrice: apiPricing.videoMinute.toFixed(2),
  exampleMinutes: 300 * 30 * 30 / 60,
  exampleCost: (300 * 30 * 30 / 60 * apiPricing.videoMinute).toLocaleString('en-US'),
};

export const contactEmail = 'contact@oredact.com';
export const apiContactHref = `mailto:${contactEmail}?subject=${encodeURIComponent('ORedact API 试用 / API trial')}`;
export const damayaUrl = 'https://damaya.cn';
